module.exports = __webpack_public_path__ + "img/avatar_4.84d1f75c.png";